import React, { useEffect, useRef } from "react";
import { useRouter } from "next/router";
import videojs from "video.js";
import "videojs-mux";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import withAuth from "../src/utils/withAuth";

const useStyles = makeStyles((theme) => ({
  videoLoading: {
    height: "198px",
    width: "auto",
    background: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const muxEnvKey = process.env.MUX_ENV_KEY || "sba2h6am8j018bv9t8fvktdoo";

export default withAuth(function VideoPlayer(props) {
  const router = useRouter();
  const classes = useStyles();
  const videoPlayerRef = useRef();
  const { src, poster, playbackSpeed, loading, auth, id, title, upNextId } =
    props;

  useEffect(() => {
    if (!loading) {
      // Record the player init time
      const playerInitTime = Date.now();

      const player = videojs(
        // Use ref in place of "this" since we're using functional component
        videoPlayerRef.current,
        // Video player
        {
          playbackRates: playbackSpeed ? [0.5, 1, 1.5, 2] : [],
          plugins: {
            mux: {
              debug: true,
              data: {
                env_key: muxEnvKey,

                // Metadata
                player_name: "Main Player",
                player_init_time: playerInitTime,
                viewer_user_id:
                  auth && auth.authenticated
                    ? auth.userData.username
                    : "anonymous",
                page_type: "watchpage",
                video_id: id,
                video_title: title,
                video_poster_url: poster,
              },
            },
          },
        },
        // Video player ready callback.
        () => {
          player.src(src);
          player.controls(true);
          player.aspectRatio("16:9");
          player.poster(poster);
          player.preload("auto");
          player.autoplay(true);
        }
      );

      // if (upNextId) {
      //   router.prefetch(`/video/${upNextId}`)
      //   player.on('ended', () => {
      //     setTimeout(() => {
      //       router.push(`/video/${upNextId}`)
      //     }, 1500)
      //   })
      // }

      return () => {
        player.dispose();
      };
    }
  }, []);

  return (
    <>
      {loading ? (
        <div className={classes.videoLoading}>
          <CircularProgress />
        </div>
      ) : (
        <div data-vjs-player>
          <video ref={videoPlayerRef} className="video-js" />
        </div>
      )}
    </>
  );
});
